import uniqid from 'uniqid';

export type PersonalInfoFormFieldName = 'firstName' | 'lastName' | 'jobTitle';

export type PersonalInfoFormFieldMode = 'CREATE_AND_EDIT_MODE';

export interface PersonalInfoFormField {
  name: PersonalInfoFormFieldName;
  label: string;
  key: string;
  mode: PersonalInfoFormFieldMode;
  renderComponentProps: Record<string, string>;
  disabled?: boolean;
  isOptional?: boolean;
}

export const PERSONAL_INFO_FORM_FIELDS: PersonalInfoFormField[] = [
  {
    name: 'firstName',
    label: 'First name',
    key: uniqid(),
    mode: 'CREATE_AND_EDIT_MODE',
    renderComponentProps: {
      autoComplete: 'given-name',
      'data-testid': 'user-first-name-input',
    },
  },
  {
    name: 'lastName',
    label: 'Last name',
    key: uniqid(),
    mode: 'CREATE_AND_EDIT_MODE',
    renderComponentProps: {
      autoComplete: 'family-name',
      'data-testid': 'user-last-name-input',
    },
  },
  {
    name: 'jobTitle',
    label: 'Job title',
    key: uniqid(),
    mode: 'CREATE_AND_EDIT_MODE',
    isOptional: true,
    renderComponentProps: {
      autoComplete: 'organization-title',
      'data-testid': 'user-job-title-input',
    },
  },
];

export const PERSONAL_INFO_FORM_ALWAYS_EDITABLE_FIELDS: Set<PersonalInfoFormFieldName> =
  new Set(['firstName', 'lastName']);
